import ReferProduct from '../models/refer-product.model';

let storeContent = utils.generateStore({
	ReferProduct,
	showReferalForm: false,
	refered_product: null,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async sendReferal(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'marketing',
							action: 'refer',
							data: {
								lead_email: data.email,
								referral_remarks: data.remarks,
								insurance_class_code:
									ctx.getters.refered_product.product_details
										.class_code,
								intermediary_ref: data.intermediary.ira_code,
							},
						},
						'/client',
					);

					ctx.commit('showReferalForm', false);
					$notify(
						'success',
						'Product Referal Sent',
						`Product referal successfully sent to ${data.email}`,
						10,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchIntermediaries(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'intermediary',
						action: 'list',
						data: {},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: ReferProduct.forms.refer_product,
					model: 'intermediary',
					label: 'intermediary_names',
					data: res.result.intermediaries,
				});

				if (form) {
					let Model = ctx.getters.ReferProduct;
					Model.forms.refer_product = form;
					ctx.commit('ReferProduct', Model);
				}
			} catch (err) {
				throw err;
			}
		},
	},
};
